import { categoriesInitialState } from './categories.state';
import {
  LoadCategoriesFailure,
  LoadCategoriesSuccess,
  CategoriesActionsUnion,
  CategoriesActionTypes
} from './categories.actions';


export function categoriesReducer(state = categoriesInitialState, action: CategoriesActionsUnion) {
  switch (action.type) {
    case CategoriesActionTypes.LOAD_CATEGORIES:
      return { ...state, loading: true, isLoaded: false };
    case CategoriesActionTypes.LOAD_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoaded: true,
        error: null,
        payload: (action as LoadCategoriesSuccess).payload
      };
    case CategoriesActionTypes.LOAD_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        isLoaded: false,
        error: (action as LoadCategoriesFailure).payload.error,
        payload: []
      };
    default:
      return state;
  }
}
